module.exports = __webpack_public_path__ + "static/alive_banner2-5a6dfaa86ba323a466847e1f300c8c6b.svg";